export default function TextEntity({ title, content }) {
  return (
    <div className="text-sm">
      <p className="text-[#252B37] font-medium leading-[22px]">{title}</p>
      <p className="text-[#717680] font-normal leading-[20px]">{content}</p>
    </div>
  );
}
